import { render, staticRenderFns } from "./StockTradeDocumentForm.vue?vue&type=template&id=a8a60050"
import script from "./StockTradeDocumentForm.vue?vue&type=script&lang=js"
export * from "./StockTradeDocumentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports